<template>
  <div class="select-game-empty">
    <empty-state
      title="您搜索的商品未在售~"
      description="可以尝试更换关键词或浏览其他游戏商品"
    ></empty-state>
  </div>
</template>

<script>
import EmptyState from "@/components/emptyState"

export default {
  name: "empty",
  components: {
    EmptyState
  }
}
</script>

<style scoped lang="less">
.select-game-empty {
  width: 1200px;
  max-width: 100%;
  min-height: 450px;
  box-sizing: border-box;
  background: var(--bg-card, #FFFFFF);
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
